import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import { encrypt, decrypt } from '@utils/local-storage'
import store from '@state/store'
import jwt_decode from "jwt-decode"

let _moment = require('moment')

let serverUrl = getSecret('SERVER_MASTER_URL')
let serverFormsUrl = getSecret('SERVER_FORMS_URL')

export const state = {
  forms_cached: {},
  sessions_cached: {},
}

export const getters = {
  forms_cached: state => {
    const forms_stored = getSavedState('forms_cached')
    if (Object.keys(state.forms_cached).length === 0 && Object.keys(forms_stored).length > 0) {
      return forms_stored
    }
    return state.forms_cached
  },
  sessions_cached: state => {
    const sessions_stored = getSavedState('sessions_cached')
    if (Object.keys(state.sessions_cached).length === 0 && Object.keys(sessions_stored).length > 0) {
      return sessions_stored
    }
    return state.sessions_cached
  }
}

export const mutations = {
  CACHE_FORMSMANAGERS(state, forms) {
    saveState('forms_cached', forms);
    state.forms_cached = forms
  },
  CACHE_FORMSESSIONS(state, session) {
    let sessions_stored = getSavedState("sessions_cached");
    let finded = false
    if (session.hasOwnProperty('key')) {
      sessions_stored.forEach((item, index) => {
        if (item.key === session.key) {
          sessions_stored[index] = session
          finded = true
        }
      })
    }
    if (!finded) {
      sessions_stored.push(session);
    }
    saveState('sessions_cached', sessions_stored);
    state.sessions_cached = sessions_stored
  },
}

export const actions = {
  getSecretaries(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/secretarities/${query}`).then((response) => {
      return response.data
    })
  },

  getIndicators(context, query, id) {
    query = query || ''
    return axios.get(`${serverUrl}/api/secretariatindicators/${(id ? id + '/' : '')}${query}`).then((response) => {
      return response.data
    })
  },

  getProjects(context, query, id) {
    query = query || ''
    return axios.get(`${serverUrl}/api/secretariatprojects/${( id ? id + '/' : '')}${query}`).then((response) => {
      return response.data
    })
  },

  getCommunes(context, query, id) {
    query = query || ''
    return axios.get(`${serverUrl}/api/communes/${(id ? id + '/' : '')}${query}`).then((response) => {
      return response.data
    })
  },

  getNeighborhoods(context, query, id) {
    query = query || ''
    return axios.get(`${serverUrl}/api/neighborhoods/${(id ? id + '/' : '')}${query}`).then((response) => {
      return response.data
    })
  },

  getForms(context, payload) {
    let params = payload || {}
    let formId
    let query
    if (Object(params).hasOwnProperty('formId')) {
      formId = params.formId + '/'
      query = params.query || ''
    } else {
      formId = ''
      query = payload.query || ''
    }
    return axios.get(`${serverUrl}/api/forms/${formId}${query}`).then((response) => {
      return response.data
    })
  },
  deleteForm(context, form) {
    let promise = null
    promise = axios.delete(`${serverUrl}/api/forms/${form.id}/?validation=${form.validate}`)
    return promise.then((response) => {
      return response.data
    })
  },

  getFormsManaged({ commit }, query) {
    query = query || ''
    query += "&user_id=" + getCurrentSessionUser().user.id
    return axios
      .get(`${serverUrl}/api/formsmanagers/${query}`)
      .then((response) => {
        commit('CACHE_FORMSMANAGERS', response.data)
        return response.data
      })
      .catch((err) => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando formularios',
        })
        return err.response
      })
  },
  getFormsManagedById({ commit }, query) {
    query = query || ''
    query += "&user_id=" + getCurrentSessionUser().user.id
    return axios
      .get(`${serverUrl}/api/formsmanagers/${query}`)
      .then((response) => {
        // commit('CACHE_FORMSMANAGERS', response.data)
        return response.data
      })
      .catch((err) => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando el formulario',
        })
        return err.response
      })
  },

  getFormsManagedNoToken({ commit }, data) {
    data.query = data.query || ''
    let decoded = jwt_decode(data.token);
    data.query += `&user_id=${decoded.user_id}`
    return axios
      .get(`${serverUrl}/api/formsmanagers/${data.query}`, {
        headers: {
          'Authorization': `key ${data.token}`
        }
      })
      .then((response) => {
        return response.data
      })
      .catch((err) => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando formularios',
        })
        return err.response
      })
  },

  createFormsManaged({ commit }, formData) {
    let promise = null
    if (formData.id !== null) {
      promise = axios.put(`${serverUrl}/api/formsmanagers/${formData.form}/`, formData)
    } else {
      promise = axios.post(`${serverUrl}/api/formsmanagers/`, formData)
    }
    return promise.then((response) => {
      return response.data
    })
  },

  getBaseVariables() {
    return axios.get(`${serverUrl}/api/variables/`).then((response) => {
      return response.data
    })
  },

  getCountQueueSessions(context, formId) {
    const sessions_stored = getSavedState("sessions_cached");
    if (formId !== null) {
      return sessions_stored.filter((x) => x.form == formId).length
    }
    return sessions_stored.length
  },


  setFormSession({ commit }, data) {
    if (!data.hasOwnProperty('key')) {
      Object.assign(data, { key: Date.now() })
    }
    if (data.hasOwnProperty('start_time')) {
      if (!data.hasOwnProperty('end_time')) {
        Object.assign(data, { end_time: _moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ') })
      }
    } else {
      Object.assign(data, { start_time: _moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ') })
    }

    if (!window.navigator.onLine) {
      if (data.mode === 'record') {
        commit('CACHE_FORMSESSIONS', data)
      } // else mode: 'sync'
      const sessions_stored = getSavedState("sessions_cached");
      return { id: null, key: data.key, queue_sessions: sessions_stored.length, start_time: data.start_time }
    } else {
      let promise = null
      if (data.hasOwnProperty('id') && data.id !== null) {
        const payload = {
          form: data.form,
          form_manager: data.form_manager,
          key: data.key || Date.now(),
          id: data.id,
          state: 'F',
          detail: data.dimensions,
          end_time: data.end_time ? data.end_time : null,
          codigoFamilia: data.codigoFamilia ? data.codigoFamilia : null
        }
        if (data.hasOwnProperty('codigoFamilia')) {
          payload.codigoFamilia = data.codigoFamilia
        }
        promise = axios.put(`${serverFormsUrl}/api/filloutform/${payload.id}/`, payload)
      } else {
        const payload = {
          form: data.form,
          form_manager: data.form_manager,
          key: data.key || Date.now(),
          state: data.end_time ? 'F' : 'C',
          detail: data.dimensions,
          start_time: data.start_time,
          end_time: data.end_time ? data.end_time : null,
          codigoFamilia: data.codigoFamilia ? data.codigoFamilia : null
        }
        if (data.hasOwnProperty('codigoFamilia')) {
          payload.codigoFamilia = data.codigoFamilia
        }
        promise = axios.post(`${serverFormsUrl}/api/filloutform/`, payload)
      }
      return promise.then((response) => {
        if (Object(response.data).hasOwnProperty('id')) {
          // remove from localStorage:
          removeFromStorage("sessions_cached", response.data.key)
          const sessions_stored = getSavedState('sessions_cached');
          console.log('sessions_stored',sessions_stored)
          response.data['queue_sessions'] = sessions_stored.length
          return response.data
        } else {

          store.dispatch('utils/message', {
            type: 'error',
            title: 'Error al guardar el formulario',
            // text: errors,
          })
        }
      })
    }
  },

  getFormSession(context, data) {
    // NOTA: Esto, por si solicitaran habilitar edición de formulario diligenciado (no se ha completado)
    return data
  },

  getFormSessions(context, form_id) {
    
    let user_id = getCurrentSessionUser().user.username || ''
    return axios.get(`${serverFormsUrl}/api/filloutform/?form_id=${form_id}&meta__created_by=${user_id}&page_size=50`).then((response) => {
      return response.data
    })
  },

  createForm(context, formData) {
    // console.log('esto es la data enviada', formData)
    let promise = null
    if (formData.id !== null) {
      promise = axios.put(`${serverUrl}/api/forms/${formData.id}/`, formData)
    } else {
      promise = axios.post(`${serverUrl}/api/forms/`, formData)
    }
    return promise.then((response) => {
      return response.data
    })
  },

  createFormExtVars(context, formData) {
    // console.log('esto es la data enviada', formData)
    let promise = null
    if (formData.form) {
      promise = axios.put(`${serverUrl}/api/formsdimensions/${formData.form}/`, formData)
    } else {
      promise = axios.post(`${serverUrl}/api/formsdimensions/`, formData)
    }
    return promise.then((response) => {
      return response.data
    })
  },
  getAutoCompleteData(context, data) {
    return axios.post(`${serverFormsUrl}/api/persons/autocomplete/`, data).then((response) => {
      return response.data
    })
  },
  setVariableFile(context, { formData }) {
    let promise = null
    promise = axios.post(`${serverFormsUrl}/api/filloutform/set_file_variable/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return promise.then((response) => {
      return response.data
    })
  },

}

// ===
// Private helpers
// ===

function getSavedState(key) {
  key = getCurrentSessionUser().user.username + '.' + key
  let returno = getStateLocalStorage(key)
  return returno
}
function saveState(key, state) {
  key = getCurrentSessionUser().user.username + '.' + key
  saveStateLocalStorage(key, state)
}

function removeFromStorage(key, item) {
  let Localstorage=getSavedState(key)
  if(Localstorage){
    let records = Localstorage.filter((x) => { return String(x.key) !== String(item) })
  saveState(key, records)
  }
  
}

function getCurrentSessionUser() {
  let user = getStateLocalStorage('auth.currentSession')
  if (user == null || user.length < 0) {
    user = JSON.parse('[{"user":{"username":"","id":0}}]')
  }
  return user
}

function getStateLocalStorage(key) {
  let storage = window.localStorage.getItem(key)
  if (storage != null) {
    if (typeof (storage) == Object && storage.length < 0) {
      return JSON.parse('[]')
    }
    return JSON.parse(decrypt(storage))
  } else {
    return JSON.parse('[]')
  }
}

function saveStateLocalStorage(key, state) {
  window.localStorage.setItem(key, encrypt(JSON.stringify(state)))
}
